<template lang="pug">
div
  BriqDurationInput.duration-input(
    data-test-id="extra-time-in-advance-input"
    label="Extra time in advance"
    :useInputInIsoFormat="true"
    :hideClearButton="true"
    help="Amount of time the parallel product is scheduled before the start of the first activity"
    :excludeSeconds="true"
    :disabled="disabled"
    v-model="product.ProductDurationConfig.ParallelExtraTimeBeforeStart"
    )
  BriqDurationInput.duration-input(
    data-test-id="extra-time-after-input"
    label="Extra time after"
    :useInputInIsoFormat="true"
    :hideClearButton="true"
    help="Amount of time the parallel product is scheduled after the end of the last activity"
    :excludeSeconds="true"
    :disabled="disabled"
    v-model="product.ProductDurationConfig.ParallelExtraTimeAtEnd"
    )
  BriqDurationInput(
    data-test-id="minimum-duration-input"
    label="Minimum duration"
    :disabled="disabled"
    v-model="product.ProductDurationConfig.MinimumDuration"
    :useInputInIsoFormat="true"
    :hideClearButton="true"
    :excludeSeconds="true"
    )
  BriqDurationInput(
    data-test-id="maximum-duration-input"
    label="Maximum duration"
    :disabled="disabled"
    v-model="product.ProductDurationConfig.MaximumDuration"
    :error="maximumDurationError"
    :useInputInIsoFormat="true"
    :hideClearButton="true"
    :excludeSeconds="true"
    @blur="vuelidate.product.MaximumDuration.$touch()"
    )
</template>

<script>
import BriqDurationInput from '@v/components/BriqDurationInput.vue'

export default {
  name: 'ProductSchedulingConfig',
  components: {
    BriqDurationInput,
  },
  props: {
    product: Object,
    disabled: Boolean,
    maximumDurationError: String,
    startDurationError: String,
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.product-scheduling-placeholder
  background-color grey200
  border-radius 5px
  padding 15px
  margin-top 10px
</style>
